const TOGGLE_ICON_TRANSITION_MS = 150;
const PROGRESS_HOVER_TRANSITION_MS = 150;
const containerCls = "futcf4tsfo";
const toggleCls = "futt21qta8";
const toggleIconCls = "futt9g5n9w";
const toggleThrobberCls = "futt1y59fzb";
const progressbarCls = "futp7chgep";
const progressLineCls = "futpsou2yx";
const progressHoverTransitionCls = "futphkrl5c";
const progressHoverLabelCls = "futp1n4ormc";
const timestampCls = "futti2v98q";
const timestampSeparatorCls = "futths41py";
const closeButtonCls = "futcxj99sm";

export { PROGRESS_HOVER_TRANSITION_MS, TOGGLE_ICON_TRANSITION_MS, closeButtonCls, containerCls, progressHoverLabelCls, progressHoverTransitionCls, progressLineCls, progressbarCls, timestampCls, timestampSeparatorCls, toggleCls, toggleIconCls, toggleThrobberCls };
import "./audio-player.styles.linaria.module.css";
//# sourceMappingURL=audio-player.styles.js.map
